import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/facilities",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Facilities",
        href: "/settings/workspace/facilities",
      },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "facility:read",
      "/settings/workspace/general",
    ),
})
